import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57ea09fe&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=57ea09fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea09fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ea09fe')) {
      api.createRecord('57ea09fe', component.options)
    } else {
      api.reload('57ea09fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57ea09fe&scoped=true&", function () {
      api.rerender('57ea09fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonFile/index.vue"
export default component.exports